export const detectDefaultLocale = async () => {
  // Check localStorage first
  const savedLocale = localStorage.getItem('userLocale')
  if (savedLocale) return savedLocale

  // 1. Try IP-based detection
  try {
    const res = await fetch('https://ipapi.co/json/')
    const data = await res.json()
    // return data.country_code === 'UA' || data.country_code === 'RU'
    return data.country_code === 'UA' ? 'uk' : 'en'
  } catch (e) {
    // 2. Try browser language first
    const browserLang = navigator.language || navigator.userLanguage

    if (browserLang?.startsWith('uk') || browserLang?.startsWith('ru'))
      return 'uk'
    if (browserLang?.startsWith('en')) return 'en'

    // 3. Fallback: Try system locale
    const systemLocale = Intl.DateTimeFormat().resolvedOptions().locale
    if (systemLocale?.startsWith('uk') || systemLocale?.startsWith('ru'))
      return 'uk'
    if (systemLocale?.startsWith('en')) return 'en'

    return 'en'
  }
}
